<script lang="ts">
	import { getNumBackInUnits } from '$lib/util/util';
	import BigNumber from 'bignumber.js';
	import { currentMarket, currentMarketAsset } from '../store';
	import { longOrShort, input, inputUnit } from './store';
	import GradientBorder from '$lib/util/GradientBorder.svelte';
	import FeeInfoSection from './FeeInfoSection.svelte';
	import EstimatedOpRewards from './EstimatedOpRewards.svelte';

	$: mainCurrencyOutput =
		$currentMarket && $input
			? getNumBackInUnits(
					new BigNumber($input)
						.dividedBy($currentMarket?.currentMarketPrice)
						.multipliedBy(1e18)
						.toString(),
					18,
					4
			  )
			: 0;

	$: secondayCurrencyOutput = getNumBackInUnits($input, 18, 2);
</script>

<GradientBorder
	gradient="bg-fx-gradient-6"
	paddingClass="p-px"
	borderRadius="rounded-xl squircle-xl"
	outerClassList="w-full mb-2"
	innerClassList="flex justify-center items-center bg-fx-black w-full"
>
	<div class="bg-fx-gradient-8 w-full p-2 rounded-xl squircle-xl">
		<div class="flex w-full justify-between mb-2">
			<div class="font-medium text-fx-white text-sm">
				{#if $inputUnit == 'USD'}
					{mainCurrencyOutput}
					{$currentMarketAsset}
					<span class="text-xs text-fx-grey-400 px-1">(${secondayCurrencyOutput})</span>
				{:else}
					${secondayCurrencyOutput}
					<span class="text-xs text-fx-grey-400 px-1"
						>(
						{mainCurrencyOutput}
						{$currentMarketAsset} )</span
					>
				{/if}
			</div>
			<GradientBorder
				gradient="bg-fx-gradient-6"
				paddingClass="p-px"
				borderRadius="rounded-lg squircle-lg"
				outerClassList="w-fit h-fit"
				innerClassList="/''bg-fx-black"
			>
				{#if $longOrShort == 'Long'}
					<div
						class="bg-fx-gradient-8 px-4 py-1 text-fx-gradient-23 text-xs font-medium rounded-lg squircle-lg"
					>
						Long
					</div>
				{:else}
					<div
						class="bg-fx-gradient-8 px-4 py-1 text-fx-gradient-22 text-xs font-medium rounded-lg squircle-lg"
					>
						Short
					</div>
				{/if}
			</GradientBorder>
		</div>
		<!--
		<div class="my-2">
			<EstimatedOpRewards />
		</div>
		-->
		<FeeInfoSection />
	</div>
</GradientBorder>
